// import React from "react";
// import "./PainterServiceSections.css";

// const PainterProcess = ({ data }) => {
//   return (
//     <section className="pnt-process">
//       <div className="pnt-container">
//         <div className="pnt-section-head">
//           <span className="pnt-tag">Our Process</span>
//           <h2 className="pnt-heading">{data.title}</h2>
//           <p className="pnt-subheading">{data.titleDesc}</p>
//         </div>

//         <div className="pnt-timeline">
//           <div className="pnt-timeline-line" />
//           {data.main.map((step, index) => (
//             <div className={`pnt-timeline-step pnt-fade ${index % 2 === 1 ? "pnt-timeline-step-alt" : ""}`} key={index}>
//               <div className="pnt-timeline-dot">{index + 1}</div>
//               <div className="pnt-timeline-card">
//                 <div className="pnt-timeline-icon">
//                   <img src={step.icon} alt={step.title} />
//                 </div>
//                 <h3>{step.title}</h3>
//                 <p>{step.description}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default PainterProcess;









import React from "react";
import "./PainterServiceSections.css";

const PainterProcess = ({ data }) => {
  return (
    <section className="pnt-process">
      <div className="pnt-container">
        <div className="pnt-section-head">
          <span className="pnt-tag">Our Process</span>
          <h2 className="pnt-heading">{data.title}</h2>
          <p className="pnt-subheading">{data.titleDesc}</p>
        </div>

        <div className="pnt-timeline">
          <div className="pnt-timeline-line" />
          {data.main.map((step, index) => {
            const stepNumber = index + 1; // 1, 2, 3, 4...
            const isRightSide = stepNumber % 2 === 0; // true for 2,4,6...

            return (
              <div
                className={`pnt-timeline-step pnt-fade ${isRightSide ? "pnt-timeline-step-alt" : ""
                  }`}
                data-step={stepNumber}   // 👈 explicit identifier
                key={index}
              >
                <div className="pnt-timeline-dot">{stepNumber}</div>
                <div className="pnt-timeline-card">
                  <div className="pnt-timeline-icon">
                    <img src={step.icon} alt={step.title} />
                  </div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PainterProcess;